import {
    initRoutes,
    getsRouteByName
} from "@/utils/routing.utils";

initRoutes();

export default {
    communities: {
        fbPage: process.env.MIX_FB_PAGE_LINK,
        fbGroup: process.env.MIX_FB_GROUP_LINK,
        discord: process.env.MIX_DISCORD_LINK,
        ytChannel: process.env.MIX_YOUTUBE_CHANNEL_LINK,
        twitch: process.env.MIX_TWITCH_CHANNEL_LINK,
        giantBomb: process.env.MIX_GIANTBOMB_CHANNEL_LINK,
        fandomWiki: process.env.MIX_FANDOM_WIKI_LINK,
        redditPage: process.env.MIX_REDDIT_LINK,
        instaPage: process.env.MIX_INSTAGRAM_LINK,
        twitterPage: process.env.MIX_TWITTER_LINK,
        linkedInPage: process.env.MIX_LINKEDIN_LINK,
        goodsStore: process.env.MIX_PHYSICAL_STORE_LINK,
        website: process.env.MIX_APP_URL,
        directDonate: process.env.MIX_PAYPAL_DIRECT_DONATE_LINK
    },
    projects: {
        amwCompanyPage: process.env.MIX_AMW_COMPANY_PAGE_LINK,
        amwPage: process.env.MIX_AMW_PAGE_LINK,
        tasteTravellers: process.env.MIX_TASTE_TRAVELLERS_PAGE_LINK,
    },
    downloads: {
        googleDrive: process.env.MIX_DOWNLOAD_GAME_GOOGLE_DRIVE_LINK,
        megaNz: process.env.MIX_DOWNLOAD_GAME_MEGANZ_LINK,
        mediaFire: process.env.MIX_DOWNLOAD_GAME_MEDIAFIRE_LINK,
        oneDrive: process.env.MIX_DOWNLOAD_GAME_ONEDRIVE_LINK,
        direct: process.env.MIX_DOWNLOAD_GAME_DIRECT_LINK,
        files: process.env.MIX_DOWNLOAD_GAME_FILES_LINK,
        windowIssue: process.env.MIX_DOWNLOAD_FIX_WINDOW_ISSUE,
        gameExe: process.env.MIX_GAME_LAUNCHER_DEPLOYED_EXE_URL
    },
    assets: {
        cover: process.env.MIX_APP_COVER,
        coverVideo: process.env.MIX_APP_COVER_VIDEO,
        profile: process.env.MIX_APP_IMAGE,
        icon: process.env.MIX_APP_ICON,
    },
    oAuth: {
        fb: `${window.location.protocol}//${window.location.hostname}/login/facebook`,
        twitter: `${window.location.protocol}//${window.location.hostname}/login/twitter`,
        google: `${window.location.protocol}//${window.location.hostname}/login/google`,
        github: `${window.location.protocol}//${window.location.hostname}/login/github`,
    },
    endpoints: {
        fileDownload: `${window.location.protocol}//${window.location.hostname}/api/v1/download?filename={fileName}`,
        userDataDownload: `${window.location.protocol}//${window.location.hostname}/v1/download-user-data`
    },
    routes: {
        login: getsRouteByName('client.login'),
        register: getsRouteByName('client.register'),
        logout: getsRouteByName('client.logout'),
        tc: getsRouteByName('client.tc'),
        tcConditions: getsRouteByName('client.tc.conditions'),
        tcPolicy: getsRouteByName('client.tc.policy'),
        resetLink: getsRouteByName('client.reset.link'),
        resetPassword: getsRouteByName('client.reset.password'),
        welcome: getsRouteByName('client.landing'),
        post: () => `${window.location.origin}${window.location.pathname}?slug=`,
        deactivatedMode: `${getsRouteByName('client.landing')}?deactivated=true`,
        checkout: getsRouteByName('client.checkout'),
        checkoutCompleted: getsRouteByName('client.checkout.completed'),
        checkoutCancelled: getsRouteByName('client.checkout.cancelled'),
        admin: getsRouteByName('client.admin'),
        users: getsRouteByName('client.admin.users'),
        profile: getsRouteByName('client.profile'),
        profileOverview: getsRouteByName('client.profile.overview'),
        profileTransactions: getsRouteByName('client.profile.transactions'),
        profileCommunities: getsRouteByName('client.profile.communities'),
        profileDownloads: getsRouteByName('client.profile.downloads'),
        profilePassword: getsRouteByName('client.profile.change.password'),
        profileSettings: getsRouteByName('client.profile.settings'),
        profileOAuthSetup: getsRouteByName('client.complete.oauth.profile'),
        about: getsRouteByName('client.about'),
        faq: getsRouteByName('client.faq'),
        disenchantmentCollection: getsRouteByName('client.guides.disenchantment.collection'),
        shop: getsRouteByName('client.shop'),
        shopPopular: getsRouteByName('client.shop.popular').replace(':page/', '1').replace(':packId?', ''),
        shopPhysical: getsRouteByName('client.shop.physical'),
        shopTasteTravellers: getsRouteByName('client.shop.tasteTravellers'),
        gift: getsRouteByName('client.gift'),
        giftPoints: getsRouteByName('client.gift.points'),
        guides: getsRouteByName('client.guides'),
        events: getsRouteByName('client.events'),
        notes: getsRouteByName('client.notes'),
        accessibilityStatement: getsRouteByName('client.accessibility.statement'),
    },
    newbieGift: {
        name: 'components.newbieGift',
        icon: 'fal fa-gift',
        type: 'info'
    },
    general: {
        registerGiftLink: process.env.MIX_REGISTER_GIFT_LINK,
    },
    people: {
        founderGoku: process.env.MIX_LINKEDIN_FOUNDER_GOKU_LINK,
    }
}
